import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-uicss"
    }}>{`@theme-ui/css`}</h1>
    <p><a parentName="p" {...{
        "href": "https://bundlephobia.com/package/@theme-ui/css"
      }}><img parentName="a" {...{
          "src": "https://badgen.net/bundlephobia/minzip/@theme-ui/css",
          "alt": "Minified Size on Bundlephobia"
        }}></img></a></p>
    <p><inlineCode parentName="p">{`@theme-ui/css`}</inlineCode>{` contains the framework-agnostic core logic of Theme UI. It lets
you write style objects with responsive, theme-aware ergonomic shortcuts.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm i @theme-ui/css
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { css as transformStyleObject } from '@theme-ui/css'
import { css as createClassName } from '@emotion/css'

const root = document.getElementById('root')

/** @type {import("@theme-ui/css").Theme} */
const theme = {
  colors: {
    text: '#222',
  },
  fonts: {
    mono: 'monospace',
  },
  space: {
    sm: '1rem',
    md: '2rem',
  },
}

const styles = transformStyleObject({
  padding: ['sm', 'md'],
  border: ({ colors }) => \`2px solid \${colors.text}\`,
  h1: {
    fontFamily: 'mono',
    color: 'text',
  },
})(theme)

root.classList.add(createClassName(styles))
root.innerHTML = \`
<h1>You can use <code>@theme-ui/css</code> in Vanilla JS!</h1>
\`
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/theme-ui-css-framework-agnostic-2c0ue?file=/src/index.js"
      }}>{`See the snippet above on CodeSandbox`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      